import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({ selector: '[dropdownMenuTrigger]' })
export class DropdownMenuTriggerDirective {
  readonly templateRef = inject(TemplateRef);
}
